import { REGISTRATION_PASSWORD_LENGTH_MIN, REGISTRATION_PASSWORD_LENGTH_MAX } from "../../config";

export default function validatePassword(password: string): boolean {
  if (password.length < REGISTRATION_PASSWORD_LENGTH_MIN) return false;
  if (password.length > REGISTRATION_PASSWORD_LENGTH_MAX) return false;
  return true;
}
